import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");




export const fetchsuivieBl = createAsyncThunk("suivieBl/allsuivieBl", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "suivieBl/allsuivieBl", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const suivieBl = await response.json();
  return suivieBl;
});



export const fetchsuivieBlForListe = createAsyncThunk("suivieBl/allsuivieBlForList", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "suivieBl/allsuivieBlForList", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const suivieBl = await response.json();
  return suivieBl;
});



export const checkProduit = createAsyncThunk("suivieBl/checkProduit", async (action) => {

  const response = await fetch(Configuration.BACK_BASEURL + "suivieBl/checkProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token // Make sure 'token' is defined
    },
    body: JSON.stringify(action)
  });
  const suivieBl = await response.json();
  return suivieBl;
});


//upload BL file
export const saveFile = createAsyncThunk("suivieBl/saveFile", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "suivieBl/saveFile", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const suivieBl = await response.json();
  return suivieBl;
});



export const verifEntete = createAsyncThunk("suivieBl/verifEntete", async (action) => {
  // console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "suivieBl/verifEntete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const suivieBl = await response.json();
  return suivieBl;
});



export const AddedExcel = createAsyncThunk("suivieBl/enteteAddedExcel", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "suivieBl/enteteAddedExcel", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const suivieBl = await response.json();
  return suivieBl;
});


// for export excel
export const fetchSuivieBlOnly = createAsyncThunk("suivieBl/allhissuivieBl", async (action) => {
  console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "suivieBl/allhissuivieBl", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const suivieBl = await response.json();
  return suivieBl;
});



export const suivieBlDeleted = createAsyncThunk("suivieBl/delete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "suivieBl/delete/" + action.id, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const suivieBl = await response.json();
  return suivieBl;
});


export const verifExistance = createAsyncThunk("suivieBl/verifExistance", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "suivieBl/verifExistance", {
      method: 'POST',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': token
      },
      body: JSON.stringify(action)
  });
  const suivieBl = await response.json();
  return suivieBl;
});



const suivieBlReduce = createSlice({
  name: "suivieBl",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
  },
  extraReducers: {
  },
});


export default suivieBlReduce.reducer;